import { Outlet } from "react-router-dom";
import { Toaster } from "@landnest/ui";

export function RootLayout() {
  return (
    <>
      <Outlet />
      <Toaster richColors position="bottom-right" />
    </>
  );
}
